export default __webpack_public_path__ + "static/media/filter.836beaea.svg";